import $ from 'jquery';

export default class Field {
	constructor(options) {
		const defaults = {
			el: '.js-field',

			dom: {
				input: '.js-field-input',
				eye: '.js-field-eye',
				email: '.js-field-email',
				cityInput: '.js-input-city',
				nameInput: '.js-input-name',
				surnameInput: '.js-input-surname',
				patronymicInput: '.js-input-patronymic'
			},
			classes: {
				eye: {
					state: {
						opened: 'field__eye_state_opened'
					}
				},
				email: {
					state: {
						error: 'field__input_state_error'
					}
				}
			},
			text: {
				email: {
					cyr: 'Указан некорректный email'
				}
			},
			validate: {
				name: {
					data: {
						'msg-target': 'siblings/.field__error',
						'invalid-length-msg': 'Минимальное кол-во символов - 2',
						'invalid-value-msg': 'В поле введены некорректные символы',
						'empty-value-msg': 'Введите имя',
						'data-input-pattern': '[a-zа-яёії\' \-]',
						'input-pattern-flags': 'i'
					},
					pattern: '^[a-zа-яёії]+[a-zа-яёії\' \-]*[a-zа-яёії]+$',
					flags: 'i',
					minlength: 2,
					maxlength: 100,
					trim: true
				},
				surname: {
					data: {
						'msg-target': 'siblings/.field__error',
						'invalid-length-msg': 'Минимальное кол-во символов - 2',
						'invalid-value-msg': 'В поле введены некорректные символы',
						'empty-value-msg': 'Введите фамилию',
						'data-input-pattern': '[a-zа-яёії\' \-]',
						'input-pattern-flags': 'i'
					},
					pattern: '^[a-zа-яёії]+[a-zа-яёії\' \-]*[a-zа-яёії]+$',
					flags: 'i',
					minlength: 2,
					maxlength: 100,
					trim: true
				},
				patronymic: {
					data: {
						'msg-target': 'siblings/.field__error',
						'invalid-length-msg': 'Минимальное кол-во символов - 2',
						'invalid-value-msg': 'В поле введены некорректные символы',
						'empty-value-msg': 'Введите отчество',
						'data-input-pattern': '[а-яёії\' \-]',
						'input-pattern-flags': 'i'
					},
					pattern: '^[a-zа-яёії]+[a-zа-яёії\' \-]*[a-zа-яёії]+$',
					flags: 'i',
					minlength: 2,
					maxlength: 100,
					trim: true
				},
				email: {
					data: {
						'msg-target': 'siblings/.field__error',
						'invalid-value-msg': 'Указан некорректный email',
						'empty-value-msg': 'Введите email'
					},
					trim: true
				},
				password: {
					data: {
						'msg-target': 'siblings/.field__error',
						'invalid-length-msg': 'Минимальное кол-во символов - 6',
						'invalid-value-msg': 'В поле введены некорректные символы',
						'empty-value-msg': 'Введите пароль'
					},
					pattern: '^[^ ]+$',
					flags: 'i',
					minlength: 6,
					maxlength: 20
				},
				city: {
					data: {
						'msg-target': 'siblings/.field__error',
						'invalid-value-msg': 'В поле введены некорректные символы',
						'empty-value-msg': 'Введите город',
						'data-input-pattern': '[a-zа-яёії \-]',
						'input-pattern-flags': 'i'
					},
					pattern: '^[a-zа-яёії]+[a-zа-яёії \-]*[a-zа-яёії]+$',
					flags: 'i',
					maxlength: 100,
					trim: true
				},
				phone: {
					data: {
						'msg-target': 'siblings/.field__error',
						'invalid-value-msg': 'Неверный номер',
						'empty-value-msg': 'Введите номер телефона'
					}
				}
			},
			regExp: /[А-Я-Ё]/i
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
	}

	getDom() {
		this.$input = this.$el.find(this.options.dom.input);
		this.$email = $(this.options.dom.email);
		this.$emailInput = this.$email.find('input');
		this.$nameInput = this.$el.find(this.options.dom.nameInput);
		this.$surnameInput = this.$el.find(this.options.dom.surnameInput);
		this.$patronymicInput = this.$el.find(this.options.dom.patronymicInput);
		this.$cityInput = this.$el.find(this.options.dom.cityInput);
		this.$passwInput = this.$el.find('[type="password"]');
		this.$phoneInput = this.$el.find('[type="tel"]');
		this.$eye = this.$el.find(this.options.dom.eye);
	}

	togglePassword = event => {
		const $target = $(event.target);
		const $el = $target.closest(this.options.el);
		const $eye = $el.find(this.options.dom.eye);
		const $input = $el.find(this.options.dom.input);

		if ($input.attr('type') === 'password') {
			$input.attr('type', 'text');
			$eye.addClass(this.options.classes.eye.state.opened);
			$eye.attr('title', 'Скрыть символы');
		} else {
			$input.attr('type', 'password');
			$eye.removeClass(this.options.classes.eye.state.opened);
			$eye.attr('title', 'Показать символы');
		}
	};

	onInput = e => {
		const $target = $(e.target);
		const $error = $target.next();
		const $val = $target.val();
		const isCyrrilic = this.options.regExp.test($val);
		if (isCyrrilic) {
			$target.addClass(this.options.classes.email.state.error);
			$error.text(this.options.text.email.cyr);
		} else {
			$target.removeClass(this.options.classes.email.state.error);
		}
	};

	setErrorTarget = () => {
		const $textarea = $('textarea');
		$textarea.data('invalid-class-target', 'closest/.field');
		$textarea.data('invalid-class', 'field_state_error');
	};

	validate = () => {
		const validate = this.options.validate;
		this.$nameInput
			.data(validate.name.data)
			.attr('pattern', validate.name.pattern)
			.attr('pattern-flags', validate.name.flags)
			.attr('minlength', validate.name.minlength)
			.attr('maxlength', validate.name.maxlength)
			.attr('data-trim', validate.name.trim);
		this.$surnameInput
			.data(validate.surname.data)
			.attr('pattern', validate.surname.pattern)
			.attr('pattern-flags', validate.surname.flags)
			.attr('minlength', validate.surname.minlength)
			.attr('maxlength', validate.surname.maxlength)
			.attr('data-trim', validate.surname.trim);
		this.$patronymicInput
			.data(validate.patronymic.data)
			.attr('pattern', validate.patronymic.pattern)
			.attr('pattern-flags', validate.patronymic.flags)
			.attr('minlength', validate.patronymic.minlength)
			.attr('maxlength', validate.patronymic.maxlength)
			.attr('data-trim', validate.patronymic.trim);
		this.$cityInput
			.data(validate.city.data)
			.attr('pattern', validate.city.pattern)
			.attr('pattern-flags', validate.city.flags)
			.attr('maxlength', validate.city.maxlength)
			.attr('data-trim', validate.city.trim);
		this.$emailInput
			.data(validate.email.data)
			.attr('data-trim', validate.email.trim);
		this.$passwInput
			.data(validate.password.data)
			.attr('minlength', validate.password.minlength)
			.attr('maxlength', validate.password.maxlength)
			.attr('pattern', validate.password.pattern)
			.attr('pattern-flags', validate.password.flags);
		this.$phoneInput.data(validate.phone.data);
	};

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$emailInput.on('input', this.onInput);
			this.$eye.on('click', this.togglePassword);
			this.validate();
			this.setErrorTarget();
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/field/field.js
 **/